export enum ConfigurationToolIdEnum {
  FACETS_CONFIG = 'facetsConfig',
  ATTRIBUTES_RANKING = 'attributesRanking',
  HIDDEN_ATTRIBUTES = 'hiddenAttributes',
  PRODUCTS_RANKING = 'productsRanking',
  PINNED_PRODUCTS = 'pinnedProducts',
  HIDDEN_PRODUCTS = 'hiddenProducts',
}
